<template>
    <div class="context">
        <component :is="componentId"
                   @changeTopTab="switchModule"
                   :ref="componentId"></component>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import tableView from "./tableView"
    import addView from "./addView"

    export default {
        name: "",
        components: {
            tableView,
            addView
        },
        data() {
            return {
                componentId: 'tableView'
            }
        },
        methods: {
            switchModule(id) {
                this.componentId = id
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>